<template>
    <div class="productSlide">
        <div v-for="d in propDots" class="productSlideDrag" v-if="propDots" :id="'dot_' + d" style="background-color:#fff;"></div>
    </div>
</template>
<script>
export default {
    props: ['propDots'],
    updated() {

        this.propDots.forEach(id => {
            var element = document.getElementById("dot_" + id);
            element.style.background = "#fff";
        });

        var firstDot = document.getElementById("dot_0");
        firstDot.style.background = "#00B5FF";
    }

}
</script>
